import PlanningStatus from "@/views/Chat/RichResponses/PlanningStatus.vue";
import JobsiteSearch from "@/views/Chat/RichResponses/JobsiteSearch.vue";
import {AInesAssistantType, AInesRichResponseType} from "@/graphql/generated/graphql";
import RegisterBookingSummary from "@/views/Chat/RichResponses/RegisterBookingSummary.vue";
import DayCalendar from "@/views/Chat/RichResponses/DayCalendar.vue";
import WeekCalendar from "@/views/Chat/RichResponses/WeekCalendar.vue";
import MonthCalendar from "@/views/Chat/RichResponses/MonthCalendar.vue";
import JobsiteList from "@/views/Chat/RichResponses/JobsiteList.vue";
import AutopilotJobsitePreferences from "@/views/Chat/RichResponses/AutopilotJobsitePreferences.vue";
import TimesheetList from "@/views/Chat/RichResponses/TimesheetList.vue";
import DemandBrowserJobsiteList from "@/views/Chat/RichResponses/DemandBrowserJobsiteList.vue";
import InitCandidatePromotion from "@/views/Chat/RichResponses/InitCandidatePromotion.vue";
import CandidateMissingJobsiteType from "@/views/Chat/RichResponses/CandidateMissingJobsiteType.vue";
import Dummy from "@/views/Chat/RichResponses/Dummy.vue";
import {useChatStore} from "@/helper/chat/chatStore";
import {scriptedQuickChats} from "@/helper/chat/scriptedMessage";
import DemandList from "@/views/Chat/RichResponses/DemandList.vue";
import PlanningStart from "@/views/Chat/RichResponses/PlanningStart.vue";
import InitHumanRequest from "@/views/Chat/RichResponses/InitHumanRequest.vue";
import HumanRequestResponse from "@/views/Chat/RichResponses/HumanRequestResponse.vue";
import DirectDemand from "@/views/Chat/RichResponses/DirectDemand.vue";
import JobsiteListStart from "@/views/Chat/RichResponses/JobsiteListStart.vue";
import ShiftTimes from "@/views/Chat/RichResponses/ShiftTimes.vue";
import AutopilotWizardSickness from "@/views/Chat/RichResponses/AutopilotWizardSickness.vue";
import MonthKPI from "@/views/Chat/RichResponses/MonthKPI.vue";
import DemandBrowserOffeneDiensteList from "@/views/Chat/RichResponses/DemandBrowserOffeneDiensteList.vue";
import BookingSuggestionListRR from "@/views/Chat/RichResponses/BookingSuggestionListRR.vue";

export type ResponseMessageRichResponse = {type: string, reference: string}

export type RichContent = {
    type: string;
    initData: object | string | undefined;
}

export const serializeRR = (rr: ResponseMessageRichResponse) => {
    return `${rr.type}(${rr.reference})`;
}

export const convertRichResponseToRichContent = (richResponse: { type: string, reference: string }): RichContent => {
    const type = richResponse.type as string
    const ref = richResponse.reference as unknown
    let initData;

    if (typeof ref === "string") {
        try {
            initData = JSON.parse(ref);
        } catch {
            initData = ref;
        }
    } else {
        initData = ref;
    }

    return {type, initData} as RichContent
}
export const getRichComponentFor = (richContent: RichContent) => {
    switch(richContent.type) {
        case AInesRichResponseType.JobsiteList:
            return JobsiteList
        // case "demand":
        //     return DemandList
        // case "booking":
        //     return BookingList
        // case "availability":
        //     return AvailabilityList
        // case "absence":
        //     return AbsenceList
        // case "planningStatus":
        //     return PlanningStatus
        case AInesRichResponseType.DayCalendar:
            return DayCalendar;
        case AInesRichResponseType.WeekCalendar:
            return WeekCalendar;
        case AInesRichResponseType.MonthCalendar:
            return MonthCalendar
        case AInesRichResponseType.RegisterBookingSummary:
            return RegisterBookingSummary
        case AInesRichResponseType.AutopilotPlanningStatusSummary:
            return PlanningStatus
        case AInesRichResponseType.JobsiteSearch:
            return JobsiteSearch
        case AInesRichResponseType.AutopilotJobsitePreferences:
            return AutopilotJobsitePreferences
        case AInesRichResponseType.AutopilotStartPlanning:
            return PlanningStart
        case AInesRichResponseType.TimesheetJobsiteSummary:
            return TimesheetList
        case AInesRichResponseType.DemandList:
            return DemandList;
        case AInesRichResponseType.InitCandidatePromotion:
            return InitCandidatePromotion;
        case AInesRichResponseType.CandidateMissingJobsiteType:
            return CandidateMissingJobsiteType;
        case AInesRichResponseType.InitHumanRequest:
            return InitHumanRequest;
        case AInesRichResponseType.HumanRequestResponse:
            return HumanRequestResponse;
        case AInesRichResponseType.DemandBrowserJobsiteList:
            return DemandBrowserJobsiteList;
        case AInesRichResponseType.DemandBrowserOffeneDiensteList:
            return DemandBrowserOffeneDiensteList;
        case AInesRichResponseType.ShiftTimes:
            return ShiftTimes;
        case AInesRichResponseType.JobsiteListStart:
            return JobsiteListStart;
        case AInesRichResponseType.InterestedInSet:
            useChatStore().setScriptedQuickChats(scriptedQuickChats.interestedInSet)
            return Dummy
        case AInesRichResponseType.AzkMeter:
        case AInesRichResponseType.AutopilotStartWizard:
            return undefined;
        case AInesRichResponseType.DirectDemand:
            return DirectDemand
        case AInesRichResponseType.SicknessWizard:
            return AutopilotWizardSickness
        case AInesRichResponseType.MonthKpi:
            return MonthKPI
        case AInesRichResponseType.BookingSuggestion:
            return BookingSuggestionListRR
        default:
            console.log("undefined rich component for " + richContent.type + " - " + JSON.stringify(richContent));
            return undefined;
    }

}
